module.exports = __webpack_public_path__ + "img/account_wallet.ba4fc783.svg";